import script from "./Main.vue?vue&type=script&setup=true&lang=js"
export * from "./Main.vue?vue&type=script&setup=true&lang=js"

import "./Main.vue?vue&type=style&index=0&id=51215b36&lang=less&scoped=true"

import exportComponent from "E:\\王昌炯\\6-煤机厂\\coal-machinery-plant\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-51215b36"]])

export default __exports__